import { Text } from '@highlight-cp/core-ui';

const getAuthorFromEmail = (email: string) => email?.split('@')?.[0]?.replace(/[^a-zA-Z0-9]/g, ' ');

export const Author = ({ author }: { author: string | null | undefined }) => {
  return (
    <Text title={author ?? 'Unknown'} tt="capitalize">
      {author ? getAuthorFromEmail(author) : ''}
    </Text>
  );
};
